const stages = {
  TO_CALL: "to_call",
  CALLED: "called",
  SUCCESS: "success",
  ERROR: "error",
  INTERVENTION_CONFIRMED: 'intervention_confirmed'
};

const firebaseRoomStages = {
  INACTIVE: "INACTIVE",
  CALLED: "CALLED",
  RESPONDED: "RESPONDED",
  EXPIRED: "EXPIRED"
}

export { stages, firebaseRoomStages }